import { injectStrict } from '@/utils/injectStrict';
import { formModeInjectionKey } from './useVeeForm';
import { computed } from 'vue';

export function useFormMode() {
  const formMode = injectStrict(formModeInjectionKey);

  return computed(() => formMode.value);
}
